import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/store/use-theme";

export function ThemeToggle() {
	const resolvedTheme = useTheme((state) => state.resolvedTheme);
	const setTheme = useTheme((state) => state.setTheme);
	const isDark = resolvedTheme === "dark";

	return (
		<Button
			variant="outline"
			size="icon"
			onClick={() => setTheme(isDark ? "light" : "dark")}
			aria-label={isDark ? "Ativar tema claro" : "Ativar tema escuro"}
		>
			{isDark ? <Sun /> : <Moon />}
		</Button>
	);
}
